<div class="cx-update-password-component col-12 col-md-8 col-lg-6 col-xl-4">
  <div class="button-wrapper row d-flex align-items-center">
    <button sdButton [theme]="buttonThemes.Secondary" [size]="buttonSizes.Large" (click)="openModal()">
      Удалить аккаунт
    </button>
  </div>
</div>
